import { renderMoney } from '@/utils/helpers';
import React from 'react';

const labelStyle = {
    fontSize: 12,
    color: '#8c8c8c',
    marginRight: 4
};

const valueStyle = {
    fontWeight: 500,
    fontSize: 13,
    color: '#262626'
};

const totalStyle = {
    fontWeight: 600,
    fontSize: 14,
    color: '#1677ff'
};

const ServicePriceCell = ({
    regularPrice = 0,
    salePrice = 0,
    quantity = 0,
    amount = 0,
    align = 'right'
}) => {
    if (!salePrice && !amount) {
        return <span style={{ color: '#bfbfbf' }}>—</span>;
    }

    return (
        <div style={{ textAlign: align, lineHeight: 1.5 }}>
            {/* ===== Thành tiền ===== */}
            <div style={totalStyle}>
                {renderMoney(amount)}
            </div>

            {/* ===== Giá bán × số lượng ===== */}
            <div style={{ fontSize: 12 }}>
                <span style={labelStyle}>Giá bán:</span>
                <span style={valueStyle}>
                    {renderMoney(salePrice)}
                </span>
                {quantity ? (
                    <>
                        <span style={{ margin: '0 4px' }}>×</span>
                        <span style={valueStyle}>{quantity}</span>
                    </>
                ) : null}
            </div>

            {/* ===== Giá gốc ===== */}
            {regularPrice > 0 && (
                <div style={{ fontSize: 12, color: '#8c8c8c' }}>
                    Giá gốc:{' '}
                    {renderMoney(regularPrice)}
                </div>
            )}
        </div>
    );
};

export default ServicePriceCell;
